<template>
  <span>
    <v-overlay :value="fileLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog max-width="600" v-model="fileReasonDialog">
      <v-card>
        <v-card-title>Укажите причину отказа принять файл</v-card-title>
        <v-card-subtitle>Данная причина будет указана абоненту</v-card-subtitle>
        <v-card-text>
          <v-textarea v-model="sendReasonParams.reason" solo name="input-7-4"></v-textarea>
        </v-card-text>
        <v-card-text align="right">
          <v-btn @click="sendErrorReasonCancel">Отмена</v-btn>
          <v-btn @click="sendErrorReason" color="error">Отправить</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog max-width="600" v-model="declineReasonDialog">
      <v-card>
        <v-card-title>Укажите причину отказа принять заявление</v-card-title>
        <v-card-subtitle>Данная причина будет указана абоненту</v-card-subtitle>
        <v-card-text>
          <v-textarea v-model="decline_reason" solo name="input-7-4"></v-textarea>
        </v-card-text>
        <v-card-text align="right">
          <v-btn @click="sendDeclineReasonCancel">Отмена</v-btn>
          <v-btn @click="sendDeclineReason" color="error">Отправить</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog max-width="600" v-model="agreeDialog">
      <v-card>
        <v-card-title>Заявление принятно</v-card-title>
        <v-card-subtitle>Уведомление поступит на почту абонента</v-card-subtitle>
        <v-card-subtitle>Пожалуйста прикрепите файлы которые будут направлены абоненту</v-card-subtitle>
        <v-card-text>
          <v-file-input
              v-for="doc in resultDocs"
              chips :label="doc.docName" v-bind:key="doc.id" v-model="doc.file">
          </v-file-input>
          <v-card-actions>
            <v-btn @click="addResultDoc">Добавить документ</v-btn>
          </v-card-actions>
        </v-card-text>
        <v-card-text align="right">
          <v-btn @click="sendAgreeCancel">Отмена</v-btn>
          <v-btn @click="sendAgree" color="error">Отправить</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card>
      <v-row>
      <v-btn
          fab
          text
          @click="close"
      >
        <v-icon>keyboard_backspace</v-icon>
      </v-btn>
      <p style="padding-top: 15px; font-size: 18px">Заявление: {{ data.request_number }}</p>
        </v-row>
      <v-card>
        <v-card-title>
          Информация о пользователе:
        </v-card-title>
        <v-card-text>
          <v-row class="ml-2"><p class="font-weight-bold mr-2">Логин:</p> {{ data.user.username }}</v-row>
          <v-row class="ml-2"><p class="font-weight-bold mr-2">ФИО:</p> {{ data.user.last_name }} {{ data.user.first_name }} {{ data.user.middle_name }}</v-row>
        </v-card-text>
        <v-card-title>
          Информация о Лицевом счёте ({{ data.customer.customer_number }}):
        </v-card-title>
        <v-card-text>
          <span v-if="data.customer.customer_type===1">
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Снилс:</p> {{ data.customer.snils }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Фамилия:</p> {{ data.customer.last_name }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Имя:</p> {{ data.customer.first_name }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Отчество:</p> {{ data.customer.middle_name }}</v-row>
          </span>
          <span v-else-if="data.customer.customer_type===2">
            <v-row class="ml-2"><p class="font-weight-bold mr-2">ИНН:</p> {{ data.customer.company_inn }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">ОГРН:</p> {{ data.customer.company_ogrn }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Фамилия:</p> {{ data.customer.last_name }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Имя:</p> {{ data.customer.first_name }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Отчество:</p> {{ data.customer.middle_name }}</v-row>
          </span>
          <span v-else-if="data.customer_type===3">
            <v-row class="ml-2"><p class="font-weight-bold mr-2">ИНН:</p> {{ data.customer.company_inn }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">КПП:</p> {{ data.customer.company_kpp }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">ОГРН:</p> {{ data.customer.company_ogrn }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Название_организации:</p> {{ data.customer.company_full_name }}</v-row>
            <p class="font-weight-bold">Представитель</p>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Фамилия:</p> {{ data.customer.last_name }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Имя:</p> {{ data.customer.first_name }}</v-row>
            <v-row class="ml-2"><p class="font-weight-bold mr-2">Отчество:</p> {{ data.customer.middle_name }}</v-row>
          </span>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-title>
          Поступившее заявление:
        </v-card-title>
        <v-card-text>
          <v-row class="ml-2"><p class="font-weight-bold mr-2">Тип:</p> {{ data.type.name}}</v-row>
          <v-row class="ml-2"><p class="font-weight-bold mr-2">Назначен на:</p>
            <template v-if="data.assigned_user ">
                {{ data.assigned_user.last_name }} {{ data.assigned_user.first_name }} {{ data.assigned_user.middle_name }}</template> (<a @click="assignOnMe">Назначить на меня</a>)</v-row>
          <v-row class="ml-2"><p class="font-weight-bold mr-2">Дата подачи:</p> {{ data.created_at | moment("DD/MM/YYYY") }}</v-row>
          <v-row class="ml-2"><p class="font-weight-bold mr-2 pt-3">Обработать до:</p>
            <v-menu
                    ref="expiredDateMenu"
                    v-model="expiredDateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="expiredDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                        v-model="data.expired_date"
                        label="Дата истечения срока рассмотрения"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="data.expired_date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">Отмена</v-btn>
                <v-btn text color="primary" @click="saveExpiredDate">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-row>
          <v-row class="ml-2"><p class="font-weight-bold mt-2 mr-2">Статус:</p>
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip v-bind="attrs"
                          v-on="on" :class="getStatusColor(data.status.id)">{{ data.status.name }}</v-chip>
                </template>
                <v-list>
                  <v-list-item
                      v-for="status in statuses"
                      :key="status.doc_status_id"
                      @click="changeStatus(status, data)"
                  >
                    <v-list-item-title>{{ status.doc_status_name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
          </v-row>
          <v-row class="ml-2 red--text" v-if="data.status.id === 4"><p class="font-weight-bold mr-2">Причина отказа:</p> {{ data.decline_reason }}</v-row>
          <v-btn class="primary" @click="sendToExternal">Отправить заявку в энергосбыт</v-btn>
          <p>{{ this.externalSendResult }}</p>
          <p v-if="data.external_send_date">Дата отправки:{{ data.external_send_date }}</p>
        </v-card-text>
        <v-card-text v-if="closeFiles">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header class="mt-n6 mb-n6">
              <v-card-title class="ml-n6">
                <v-avatar class="mr-3 rounded-0" size="36">
                  <v-icon size="36">mdi-file-document-outline</v-icon>
                </v-avatar>
                <span class="subtitle-1 font-weight-bold mb-n1">
                  Закрывающие документы
                </span>
                </v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <v-hover v-slot:default="{ hover }"
                         v-for="file in closeFiles"
                         :key="file.doc_close_id">
                  <v-card :elevation="hover ? 12 : 2"
                          class="mx-auto mb-5">
                    <v-card-title>
                      <v-avatar class="mr-3 rounded-0" size="36">
                        <v-icon size="36">mdi-file-document-outline</v-icon>
                      </v-avatar>
                      <span class="subtitle-1 font-weight-bold mb-n1">
                        {{ file.doc_close_file.real_file_name }}({{ file.created_at | moment("DD/MM/YYYY") }})
                      </span>
                      <v-spacer></v-spacer>
                      <v-btn class="v-size--small green" dark @click="download(file.doc_close_file)">Скачать</v-btn>
                    </v-card-title>
                  </v-card>
                </v-hover>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-card-text>
        <v-card-text>
          <v-hover v-slot:default="{ hover }"
                   v-for="file in files"
                   :key="file.doc_request_attach_id">
            <v-card :elevation="hover ? 12 : 2"
                    class="mx-auto mb-5">
              <v-card-title>
                <v-btn v-if="file.comments_user_unviewed > 0" title="Не прочитано сообщений" rounded class="v-size--small red white--text"
                       icon small>
                  {{ file.comments_user_unviewed }}
                </v-btn>
                <v-avatar class="mr-3 rounded-0" size="36">
                  <v-icon size="36">mdi-file-document-outline</v-icon>
                </v-avatar>
                <span class="subtitle-1 font-weight-bold mb-n1">
                  {{ file.required_doc_type_name }}({{ file.created_at | moment("DD/MM/YYYY") }})
                </span>
                <v-spacer></v-spacer>
                <v-btn class="v-size--small green" dark @click="download(file)">Скачать</v-btn>
              </v-card-title>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header class="mt-n6 mb-n6" @click="makeViewed(file)">
                    <v-card-text>
                      <v-row>
                        <v-chip-group
                            v-model="file.doc_request_attach_status"
                        >
                            <v-chip :active-class="fileStatus.color" v-for="fileStatus in fileStatuses"
                                    :key="fileStatus.id" :value="fileStatus.id"
                                    @click="changeFileStatus(file, fileStatus)">
                              {{ fileStatus.name }}
                            </v-chip>
                          </v-chip-group>
                      </v-row>
                    </v-card-text>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card
                        v-for="comment in file.comments"
                        :key="comment.doc_attachment_comment_id"
                        :class="`d-flex justify-${getMessageAlign(comment)} mb-6`"
                        flat
                        shaped
                    >
                      <v-card
                          max-width="500"
                          :color="getMessageColor(comment)"
                          shaped
                      >
                        <v-card-text>{{ comment.doc_attachment_comment }}</v-card-text>
                      </v-card>
                    </v-card>
                    <v-card flat>
                      <v-card-text>
                        <v-row class="mt-n5 mb-n5">
                          <v-text-field rounded v-model="file.newComment" background-color="grey lighten-3"></v-text-field>
                          <p class="mt-3 ml-3">
                            <v-btn rounded @click="sendComment(file, file.newComment)">Отправить</v-btn>
                          </p>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-hover>
        </v-card-text>
      </v-card>
    </v-card>
  </span>
</template>

<script>
export default {
  name: 'DocumentRequestDetails',
  components: {
  },
  props: {
    data: {}
  },
  mounted () {
    this.localdata = this.data
    this.getDocumentsStatusApi()
    this.axios.get(`/api/users/me/`).then((response) => {
      this.currentUser = response.data
    })
      .catch((err) => {
        console.log(err)
      })
  },
  data () {
    return {
      files: [{
        doc_request_attach_doc_request: null,
        doc_request_attach_doc_required: null,
        doc_request_attach_file: null,
        doc_request_attach_id: null,
        doc_request_attach_status: null,
        file_name: null,
        required_doc_type_name: null,
        status_name: null
      }],
      closeFiles: [],
      loading: true,
      firstLoading: true,
      localdata: {},
      statuses: [],
      serverItemsLength: 0,
      editing: false,
      passwordChanging: false,
      getTimer: '',
      searchTimer: '',
      deleteTimer: '',
      fileStatuses: [
        { id: 3, name: 'На рассмотрении', color: 'blue' },
        { id: 1, name: 'Принят', color: 'green' },
        { id: 2, name: 'Отклонен', color: 'red' }
      ],
      fileReasonDialog: false,
      declineReasonDialog: false,
      decline_reason: '',
      sendReasonParams: {
        fileId: null,
        fileStatus: null,
        reason: null
      },
      currentUser: {},
      resultDocs: [],
      resultDocId: 0,
      agreeDialog: false,
      externalSendResult: '',
      fileLoading: false,
      expiredDate: new Date().toISOString().substr(0, 10),
      expiredDateMenu: false
    }
  },
  watch: {
    localdata: {
      handler () {
        this.externalSendResult = ''
        this.makeDocumentViewed()
        this.getFilesApi()
        this.getResultFilesApi()
      },
      deep: true
    }
  },
  methods: {
    getFilesApi () {
      this.loading = false
      this.axios.get(`/api/document_request_attachment/?document_id=${this.localdata.doc_request_id}`).then((response) => {
        this.files = response.data.results
        this.files.forEach(function (file) {
          file.expandedPanel = undefined
        })
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    getResultFilesApi () {
      this.loading = false
      this.axios.get(`/api/document_close_file/?document_id=${this.localdata.doc_request_id}`).then((response) => {
        this.closeFiles = response.data.results
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    getDocumentsStatusApi () {
      this.firstLoading = false
      this.loading = false
      this.axios.get(`/api/document_status/`).then((response) => {
        this.statuses = response.data.results
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    changeStatusApi (statusId) {
      this.data.status.id = statusId
      this.axios.patch(`/api/document_request/${this.data.doc_request_id}/`,
        { doc_status: statusId }).then(() => {
      }).catch((err) => {
        console.log(err)
      })
    },
    changeStatus (status) {
      if (status.doc_status_id === 4) {
        this.showDecline()
      } else if (status.doc_status_id === 3) {
        this.resultDocId = 0
        this.showAgreeDialog()
      } else {
        this.changeStatusApi(status.doc_status_id)
      }
    },
    close () {
      this.$emit('close')
    },
    download (file) {
      this.fileLoading = true
      this.axios({
        url: `/api/download/${file.file_name}`,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        var blob = new Blob([response.data], { type: response.data.type })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        const contentDisposition = response.headers['content-disposition']
        let fileName = file.file_name
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.setAttribute('download', decodeURI(fileName))
        document.body.appendChild(link)
        link.click()
        link.remove()
        this.fileLoading = false
      }).catch((err) => {
        console.log(err)
        this.fileLoading = false
      })
    },
    getStatusColor (statusId) {
      if (statusId === 2) {
        return 'orange'
      } else if (statusId === 3) {
        return 'green'
      } else if (statusId === 4) {
        return 'red'
      }
    },
    changeFileStatusApi (file, fileStatus) {
      this.axios.patch(`/api/document_request_attachment/${file.doc_request_attach_id}/`,
        { doc_request_attach_status: fileStatus.id }).then(() => {
      }).catch((err) => {
        console.log(err)
      })
    },
    showFileReasonDialog (file, fileStatus) {
      this.fileReasonDialog = true
      this.sendReasonParams.file = file
      this.sendReasonParams.fileStatus = fileStatus
      this.sendReasonParams.reason = ''
    },
    changeFileStatus (file, fileStatus) {
      if (fileStatus.id === 2) {
        this.showFileReasonDialog(file, fileStatus)
      } else {
        this.changeFileStatusApi(file, fileStatus)
      }
    },
    sendErrorReason () {
      this.changeFileStatusApi(this.sendReasonParams.file, this.sendReasonParams.fileStatus)
      this.sendComment(this.sendReasonParams.file, this.sendReasonParams.reason)
      this.fileReasonDialog = false
    },
    sendErrorReasonCancel () {
      this.sendReasonParams.fileStatus = 3
      this.fileReasonDialog = false
    },
    showDecline () {
      this.declineReasonDialog = true
    },
    sendDeclineReason () {
      this.declineReasonDialog = false
      this.axios.patch(`/api/document_request/${this.data.doc_request_id}/`,
        { doc_status: 4, decline_reason: this.decline_reason }
      ).then(() => {
        this.close()
      }).catch((err) => {
        console.log(err)
      })
    },
    sendDeclineReasonCancel () {
      this.declineReasonDialog = false
      this.decline_reason = ''
      this.data.doc_status = 2
    },
    sendComment (file, comment) {
      this.axios.post(`/api/document_request_attachment_comment/`,
        { doc_attachment: file.doc_request_attach_id,
          doc_request_id: this.data.doc_request_id,
          doc_attachment_comment: comment
        }).then(() => {
        file.newComment = ''
        this.getFilesApi()
      }).catch((err) => {
        console.log(err)
      })
    },
    makeDocumentViewed () {
      this.axios.post(`/api/document_request/${this.data.doc_request_id}/viewed/`).then(() => {
        this.localdata.new_files = 0
      }).catch((err) => {
        console.log(err)
      })
    },
    makeViewed (file) {
      this.axios.post(`/api/document_request_attachment/${file.doc_request_attach_id}/viewed/`).then(() => {
        file.comments_user_unviewed = 0
      }).catch((err) => {
        console.log(err)
      })
    },
    showAgreeDialog () {
      this.agreeDialog = true
    },
    addResultDoc () {
      this.resultDocId += 1
      this.resultDocs.push({
        id: this.resultDocId,
        file: null,
        docName: 'Документ',
        doc_required_file_id: '24'
      })
    },
    sendAgreeCancel () {
      this.agreeDialog = false
      this.resultDocs = []
      this.resultDocId = 0
    },
    sendAgree () {
      if (this.resultDocs) {
        var formData = new FormData()
        for (var docFile of this.resultDocs) {
          if (docFile.file) {
            formData.append('files', docFile.file, docFile.file.name + '$' + docFile.doc_required_file_id)
          }
        }

        formData.append('doc_request_id', this.data.doc_request_id)

        this.axios.post('/api/document_close_file/', formData).then((response) => {
          this.changeStatusApi(3)
          this.sendAgreeCancel()
          this.close()
        }).catch(error => {
          console.log(error)
        })
      } else {
        console.log('there are no files.')
      }
    },
    assignOnMe () {
      this.axios.patch(`/api/document_request/${this.data.doc_request_id}/`,
        { assigned_user_id: this.currentUser.user_id }
      ).then(() => {
        this.data.assigned_user = this.currentUser
      }).catch((err) => {
        console.log(err)
      })
    },
    sendToExternal () {
      this.axios.post(`/api/document_request/${this.data.doc_request_id}/send_to_external/`
      ).then((respose) => {
        this.externalSendResult = 'Заявка успешно отправлена'
      }).catch((err) => {
        this.externalSendResult = 'Произошла ошибка при отправке'
        console.log(err)
      })
    },
    saveExpiredDate () {
      this.$refs.expiredDateMenu.save(this.expiredDate)
      this.axios.patch(`/api/document_request/${this.data.doc_request_id}/`, { expired_date: this.data.expired_date }
      ).catch((err) => {
        console.log(err)
      })
    },
    getMessageAlign (message) {
      if (message.created_by === this.currentUser.user_id) {
        return 'end'
      } else {
        return 'start'
      }
    },
    getMessageColor (message) {
      if (message.created_by === this.currentUser.user_id) {
        return 'blue lighten-5'
      }
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/spa/documents-requests/DocumentRequestDetails.vue